import { IQService } from "angular";
import { StateService } from "angular-ui-router";
import { EventEmitter } from "../../../../common/components/event-emitter";
import { IcdCorporationDetail, IcdCorporationSelect, IcdDashboardTabSelection } from "../icd-corporation-dashboard-types";
import templateUrl from "./icd-corporation-dashboard-container.component.html";

export const IcdCorporationDashboardContainerComponent = {
    bindings: {
        icdCorporationDetails: "<",
        icdCorporationStatusList: "<",
        icdCorporations: "<",
        icdCorporationID: "<",
        permissionGrants: "<",
        tabs: "<",
        selectedTab: "<",
        changeTab: "&onChangeTab"
    },
    templateUrl,
    controller: class IcdCorporationDashboardContainer {
        icdCorporations: IcdCorporationSelect[];
        icdCorporationID: number;
        icdCorporationStatusList;
        icdCorporationDetails: IcdCorporationDetail;
        tabs: IcdDashboardTabSelection[];
        selectedTab: string;
        changeTab: EventEmitter<{ tab: string }>;
        dropdownOptions;

        constructor(private $q: IQService, private $state: StateService, private apexApiUrl: string) {
            'ngInject';
            this.dropdownOptions = {
                dataSource: new kendo.data.DataSource({
                    data: this.icdCorporations,
                }),
                headerTemplate: `
                    <div style="padding: 8px 12px; border-bottom: 1px solid \\#ddd; cursor: pointer;">
                        <label class="control control-checkbox" style="margin: 0;">
                            <input type="checkbox" id="allcorps" name="allcorps" />
                            <span class="control-indicator"></span>
                            <span>Show Active</span>
                        </label>
                    </div>
                `,
                open: () => {
                    setTimeout(() => {
                        const widget = $("#icd-corporation-list").data("kendoDropDownList");
                        const source = this.icdCorporations;
                        const statusCorps = this.icdCorporationStatusList.filter(x => x.Active).map(x => x.IcdCorporationID);
                        $("#allcorps").off("click").on("click", (e) => {
                            const isChecked = $(e.target).prop("checked");
                            console.log(this.icdCorporationStatusList);
                            const filtered = isChecked
                                ? source.filter(c => statusCorps.includes(c.Id))
                                : source;
                            widget.dataSource.data(filtered);
                            widget.refresh();
                            widget.popup.open(); // keep it open after refresh
                        });
                    }, 0);
                }
            }
        }

        $onChanges() {
            this.icdCorporationID = this.icdCorporationDetails ? this.icdCorporationDetails.Id : null;
        }

        onChangeIcdCorporation() {
            const icdCorporationID = this.icdCorporationID;
            this.$state.go("corporations.dashboard.icdSelected.tabSelected", { icdCorporationID },
                { location: "replace", reload: "corporations.dashboard" });
        }


        onChangeTab(tab: string) {
            this.selectedTab = tab;
            this.changeTab({
                $event: {
                    tab
                }
            });
        }
    }
};
